import { useNavigate } from 'react-router-dom'

// Components
import { Icon } from 'components/icon'

// Styles
import {
  ReturnContainer,
  HistoryContainer,
  HistoryTitle,
  EpochsList,
  EpochItem,
  EpochTitle,
  EpochData,
  BlockLink,
  Bold,
} from './managementHistory.styles'


import { useSafePOKTContext } from 'providers/SafePOKTProvider'
import { useState } from 'react'

interface EpochProp {
    rewardReceived?: number
    rewardDeposit?: number
    rewardPerPokt?: number
    poktSellPrice?: number
    time?: number
    feature1?:number

}


export const ManagementHistory = (): React.ReactElement => {
  const navigate = useNavigate()
  const { safePoktHistory } = useSafePOKTContext()
  const [epochsArray, setEpochsArray] = useState<EpochProp[] | []>([]);
  const [epochsNum, setEpochNum] = useState(0)
  const maxLoad = 25;
  const init = async () => {
      try {
          if (epochsNum === 0) {
              const epochs: EpochProp[] = []
              const epochsN = Number(await safePoktHistory(0, true));
              let load = 0
              if (epochsN > maxLoad) load = epochsN - maxLoad
              const promises = [];
              for (let i = epochsN; i > load; --i) {
                  promises.push(safePoktHistory(i, false))
              }
              Promise.all(promises).then((values) => {
                  for (let i = 0; i < values.length; ++i) epochs.push(values[i] as EpochProp)
                  setEpochNum(epochsN)
                  setEpochsArray(epochs)
              }).catch(err => {
                  console.log(err)
              })
          }
      } catch (error) {
          console.log(error)
      }
  }

  init()

  const tokenDecimals = 1000000
  const blockUrl = 'https://ftmscan.com/block/'
  //
  return (
    <>
      <ReturnContainer onClick={() => navigate('/')}>
        <Icon icon={'arrow_back'} />
        Return to the application
      </ReturnContainer>
      <HistoryContainer>
              <HistoryTitle> Reward Distributions </HistoryTitle>
          { (epochsNum === 0) ? (<EpochsList></EpochsList>) : (<EpochsList>
              {epochsArray.map((epoch, index) =>
                  <EpochItem key={`epoch-${index}`} >
                      <EpochTitle><BlockLink href={blockUrl + Number(epoch['time'])} target={'_blank'}>Epoch {epochsNum - index}</BlockLink></EpochTitle>
                      <EpochData>Total Reward: <Bold>{ (Number(epoch['rewardReceived']) / tokenDecimals).toFixed(0) }</Bold> POKT</EpochData>
                      <EpochData>Claimable Reward: <Bold>{ (Number(epoch['rewardDeposit']) / tokenDecimals).toFixed(0) }</Bold> USDC</EpochData>
                      <EpochData>Reward Per Share: <Bold>{ (Number(epoch['rewardPerPokt']) / tokenDecimals).toFixed(4) }</Bold> POKT</EpochData>
                  </EpochItem>
              )}
              </EpochsList> )}
      </HistoryContainer>
    </>
  )
}
